import { postConfig } from './helpers';

let iti;
let isEmailValid = false;
let isPhoneValid = false;

const checkEnableSubmitButton = () => {
  document.getElementById('wmdSubmit').disabled = !(isEmailValid && isPhoneValid);
};

const validateEmailAddress = async (event) => {
  checkEnableSubmitButton();
  const postData = postConfig({
    email: event.target.value
  });
  const response = await fetch('/apps/wmd/api/validateEmail', postData);
  if (response.status === 200) {
    const data = await response.json();
    if (data.result.verdict !== 'Invalid') {
      isEmailValid = true;
      document.getElementById('emailValid').innerText = '';
      checkEnableSubmitButton();
    }
    else {
      isEmailValid = false;
      document.getElementById('emailValid').innerText = 'Email address not valid';
      checkEnableSubmitButton();
    }
  }
  else {
    isEmailValid = false;
    document.getElementById('emailValid').innerText = 'Error validating email address';
    checkEnableSubmitButton();
  }
};


const handleSubmit = async (event) => {
  event.preventDefault();
  if(!isEmailValid || !isPhoneValid) return;
  const form = document.getElementById('wmdContactForm');
  let scrollElement;

  const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');
  let requiredEmpty = 0;
  let radioChecked = new Set();
  const emptyFields = [];
  requiredFields.forEach(field => {
    if (field.value === '' || !field.value) {
      emptyFields.push(field.name);
      requiredEmpty++;
    }
    if (field.type === 'radio') {
      if (!radioChecked.has(field.name)) {
        radioChecked.add(field.name);
        const group = form.querySelectorAll(`input[type='radio'][name='${field.name}']`);
        const oneRadioChecked = Array.from(group).some(radio => radio.checked);
        if (!oneRadioChecked) {
          emptyFields.push(field.name);
          requiredEmpty++;
        }
      }
    }
  });
  if (requiredEmpty) {
    const firstRequiredElementName = emptyFields[0];
    scrollElement = document.querySelector(`input[name='${firstRequiredElementName}']`);
    alert('Please complete all required fields');
    scrollElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    return false;
  }

  const json = serializeFormToJSON(form);
  window.grecaptcha.ready(async function() {
    const token = await window.grecaptcha.execute('6LdRSukqAAAAAIltDZRCSDNcs1gWrQ7wmzh8i_sQ', { action: 'submit' });
    const postData = postConfig({
      greToken: token,
      form: json
    });
    const response = await fetch('/apps/wmd/api/send', postData);
    const data = await response.json();

    if (data.status === 200) {
      if (window.wmd?.redirect) {
        window.location.href = window.wmd?.redirectUrl;
      }
      else {
        document.getElementById('successMessage').innerText = data.message;
        document.querySelector('.successful-post').style.display = 'block';
        document.querySelector('.unsuccessful-post').style.display = 'none';
        document.getElementById('wmdContactForm').reset();
        const scrollElement = document.getElementById(`shopify-section-${window.wmd?.scrollTarget}`);
        scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

      }
    }
    else {
      document.getElementById('failureMessage').innerText = data.message;
      document.querySelector('.unsuccessful-post').style.display = 'block';
      document.querySelector('.successful-post').style.display = 'none';
      const scrollElement = document.getElementById(`shopify-section-${window.wmd?.scrollTarget}`);
      scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
};

function serializeFormToJSON(form) {
  const formData = new FormData(form);
  const jsonObject = {};

  formData.forEach((value, key) => {
    jsonObject[key] = value;
  });

  return JSON.stringify(jsonObject);
}

const formatPhoneNumber = (event) => {
  checkEnableSubmitButton();
  const number = iti.getNumber();
  isPhoneValid = iti.isValidNumber();
  if (isPhoneValid) {
    isPhoneValid = true;
    document.getElementById('ContactForm-phone').value = number;
    document.getElementById('phoneValid').innerText = '';
    checkEnableSubmitButton();
  }
  else {
    isPhoneValid = true;
    document.getElementById('phoneValid').innerText = 'Phone number not valid';
    checkEnableSubmitButton();
  }
};

const manageUSState = (event) => {
  if (event.target.value === 'United States') {
    document.getElementById('us-state').style.display = 'block';
    document.getElementById('AddressState').disabled = false;
    document.getElementById('AddressState').required = true;
  }
  else {
    document.getElementById('us-state').style.display = 'none';
    document.getElementById('AddressState').disabled = true;
    document.getElementById('AddressState').required = false;
  }
};

const rearrangeCountries = () => {
  const selectElement = document.getElementById('AddressCountryNew');
  if (!!selectElement) {
    const topCountries = [
      'United Kingdom',
      'United States',
      'France',
      'Italy',
      'Australia',
      'Spain',
      'Ireland',
      'Netherlands',
      'Portugal',
      'Canada',
      'Germany'];
    const existingOptions = Array.from(
      new Set(Array.from(selectElement.querySelectorAll('option')).map(opt => opt.value))).
      map(value => Array.from(selectElement.querySelectorAll(`option[value="${value}"]`))[0]);

    const topOptions = [];
    let bottomOptions = [];
    existingOptions.forEach(option => {

      if (topCountries.includes(option.value) || option.value === '') {
        topOptions.push(option);
      }
      else {
        bottomOptions.push(option);
      }
      if (option.value === '---') {
        option.disabled = true;
      }
    });

    selectElement.textContent = '';

    topOptions.sort((a, b) => topCountries.indexOf(a.value) - topCountries.indexOf(b.value));

    bottomOptions.sort((a, b) => {
      if (a.value === '---') {
        return -1;
      }
      if (b.value === '---') {
        return 1;
      }
      return a.value.localeCompare(b.value);
    });

    topOptions.forEach(option => {
      selectElement.add(option);
    });

    bottomOptions.forEach(option => {
      selectElement.add(option);
    });

    selectElement.value = '';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  rearrangeCountries();
  document.getElementById('AddressCountryNew')?.addEventListener('change', manageUSState);
  document.getElementById('wmdSubmit').addEventListener('click', handleSubmit);

  if(document.getElementById('ContactForm-email')){
    const emailInputField = document.getElementById('ContactForm-email');
    emailInputField.addEventListener('change', validateEmailAddress);
  }

  if (document.getElementById('ContactForm-phone')) {
    const phoneInputField = document.getElementById('ContactForm-phone');
    iti = window.intlTelInput(phoneInputField, {
      initialCountry: 'auto',
      geoIpLookup: (success, failure) => {
        fetch('https://ipapi.co/json').
          then((res) => res.json()).
          then((data) => success(data.country_code)).
          catch(() => failure());
      },
      countryOrder: ['gb', 'us', 'fr', 'it', 'de', 'es', 'au'],
      containerClass: 'field__input'
    });
    phoneInputField.addEventListener('change', formatPhoneNumber);
  }
});

